import Logoutbtn from "icons/Logoutbtn";
import React from "react";
import {
  dispatchClearSelectedCountry,
  dispatchClearUser,
} from "store/dispatch/user.dispatch";

interface LogoutProps {
  setLogoutUser: Function;
  setLogedIn: Function;
}

export const Logout = (props: LogoutProps) => {
  return (
    <>
      <div className="fixed top-0 left-0 w-full h-full bg-black/70 px-5 backdrop-blur-md z-999 flex items-center justify-center">
        <div className="bg-white w-full sm:max-w-458px sm:min-w-458px px-5 py-8  rounded-xl z-50 text-center space-y-3 relative">
          <div className="bg-lightgray w-20 h-20 rounded-full flex items-center justify-center mx-auto">
            <Logoutbtn className="fill-black" />
          </div>
          <h5 className="text-2xl font-semibold text-black">
            Ready to sign out?
          </h5>
          <p className="text-sm font-normal text-darkgray">
            Your progress is saved. You can return anytime!
          </p>
          <div className="flex items-center justify-center gap-4 !mt-5">
            <button
              className="text-base font-normal text-black/40 hover:text-black/70 rounded-full border border-gray/30 hover:border-black/50 px-8 py-2.5 transition-all duration-300"
              onClick={() => {
                props.setLogoutUser(false);
              }}
            >
              Cancel
            </button>
            <button
              className="text-base font-normal text-white rounded-full  bg-RedT hover:bg-opacity-80 border border-RedT px-8 py-2.5 transition-all duration-300"
              onClick={() => {
                dispatchClearUser();
                dispatchClearSelectedCountry();
                props.setLogedIn(false);
                props.setLogoutUser(false);
              }}
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
